/**
 * Per-submenu-item count loaders for the Approvals navbar badge.
 *
 * Each loader is a dynamic import so the navbar bundle does not pull in those
 * feature modules (or their pages) just to show a number. Add a loader keyed
 * by the same `to` as the item in APPROVALS_NAV_ITEMS when a new queue appears.
 */

export type ApprovalsCountByPath = Record<string, number>;

const APPROVALS_COUNT_LOADERS: Record<string, () => Promise<number>> = {
  '/he-admin': loadVendorAdminCount,
};

async function loadVendorAdminCount(): Promise<number> {
  const { vendorService } = await import('../services/vendorService');
  const summary = await vendorService.getPendingSummary();
  return summary.total;
}

export function formatNavCount(count: number): string {
  if (count > 99) return '99+';
  return String(count);
}

export async function loadAwaitingApprovalsCounts(paths: string[]): Promise<ApprovalsCountByPath> {
  const unique = [...new Set(paths.filter((path) => APPROVALS_COUNT_LOADERS[path]))];
  const entries = await Promise.all(
    unique.map(async (path) => {
      try {
        const count = await APPROVALS_COUNT_LOADERS[path]();
        return [path, Number.isFinite(count) ? count : 0] as const;
      } catch {
        return [path, 0] as const;
      }
    })
  );
  return Object.fromEntries(entries);
}
